<div class="section-padding-vertical-md lg:section-padding-vertical-lg w-full flex flex-col gap">
    <div class="w-full flex flex-col items-center gap-6">
        <h2>So einfach machen wir dich zum Marktführer</h2>
        <p class="max-w-screen-sm text-center">
            Schnell. Simpel. Effektiv. Und das mit 0 Aufwand für dich.
        </p>
    </div>

    <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8 xl:gap-12">
        <div class="card before:content-['01'] before:font-medium before:text-6xl before:opacity-20">
            <div class="flex flex-col gap-4 mt-4">
                <h3 class="font-normal text-dark">Strategie, die wirkt</h3>

                <p>
                    In einem gemeinsamen Workshop tauchen wir tief in dein Unternehmen ein: Wir
                    analysieren Zielgruppen, Stärken und Ziele – und entwickeln daraus eine
                    Strategie, die dein Business perfekt positioniert.
                </p>
            </div>
        </div>

        <div class="card before:content-['02'] before:font-medium before:text-6xl before:opacity-20">
            <div class="flex flex-col gap-4 mt-4">
                <h3 class="font-normal text-dark">Fundament mit Wirkung</h3>

                <p>
                    Basierend auf der Strategie entsteht der erste Aufbau deiner Website – inklusive
                    einzigartigem Branding und verkaufspsychologisch optimierten Texten, die deine
                    Besucher gezielt führen.
                </p>
            </div>
        </div>

        <div class="card before:content-['03'] before:font-medium before:text-6xl before:opacity-20">
            <div class="flex flex-col gap-4 mt-4">
                <h3 class="font-normal text-dark">Design, das begeistert</h3>

                <p>
                    Darauf aufbauend gestalten wir ein individuelles Design, das deine Marke
                    erlebbar macht – modern, klar und mit Wiedererkennungswert.
                </p>
            </div>
        </div>

        <div class="card before:content-['04'] before:font-medium before:text-6xl before:opacity-20">
            <div class="flex flex-col gap-4 mt-4">
                <h3 class="font-normal text-dark">Technik, die läuft</h3>

                <p>
                    Nach dem Design folgt die technische Umsetzung. Deine Website wird nicht nur
                    optisch stark, sondern auch schnell und absolut zuverlässig.
                </p>
            </div>
        </div>

        <div class="card before:content-['05'] before:font-medium before:text-6xl before:opacity-20">
            <div class="flex flex-col gap-4 mt-4">
                <h3 class="font-normal text-dark">Betreuung, die bleibt</h3>

                <p>
                    Auch nach dem Launch bleiben wir an deiner Seite. Wir kümmern uns um Updates,
                    neuen Content sowie sicherheitsrelevante Einstellungen.
                </p>
            </div>
        </div>

        <div class="card bg-dark">
            <div class="flex flex-col gap-4 h-full">
                <h3 class="font-normal text-white">Gemeinsam ans Ziel</h3>

                <p class="text-white">
                    Von Beginn bis nach dem Launch unterstützen wir dich, deine Ziele zu erreichen.
                </p>

                <wci-button
                    routerLink="/kontakt"
                    label="Jetzt Marktführer werden"
                    variant="stacked"
                    buttonClass="!rounded-medium"
                    class="mt-auto">
                    <div class="flex flex-col items-center">
                        <span>Jetzt Marktführer werden</span>
                        <p class="text-xs text-center font-light">
                            Von Beginn bis nach dem Launch unterstützen wir dich, deine Ziele zu
                            erreichen.
                        </p>
                    </div>
                </wci-button>
            </div>
        </div>
    </div>
</div>
